import { Injectable, Renderer2, RendererFactory2, ElementRef, Inject } from '@angular/core';
import { CommonService } from '@tech-services/common.service';
import { BehaviorSubject, catchError, map, Observable, throwError } from 'rxjs';
import { TwoFaService as sdkService } from "@techrules/portallib";
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class TwoFAService {
  public verificationIdSource = new BehaviorSubject<string>('');
  public verificationId$ = this.verificationIdSource.asObservable();
  public showBtoCloseModalSource = new BehaviorSubject<boolean>(true);
  public showBtoCloseModal$ = this.showBtoCloseModalSource.asObservable();

  constructor(
    private commonService: CommonService,
    private sdkSvc: sdkService,
  ) {  
   }

  public verificationCode(deviceId, verificationId, code, clientcode):Observable<any> {
    return this.sdkSvc
      .verificationCode2FA(
        deviceId,
        verificationId,
        code,
        clientcode
      )
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          this.commonService.isnotloading();
          return throwError(err);
        })
      );
  }

  public resendCode(verificationId, clientcode):Observable<any> {
    return this.sdkSvc
      .resendCode(
        verificationId,
        clientcode
      )
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          this.commonService.isnotloading();
          return throwError(err);
        })
      );
  }

}
